import PropTypes from 'prop-types';

const ButtonBase = {};

ButtonBase.propTypes = {
    url: PropTypes.string,
    text: PropTypes.string,
    tabindex: PropTypes.number,
    openInNewWindow: PropTypes.bool,
    onClick: PropTypes.func,
};

export default ButtonBase;


// WEBPACK FOOTER //
// ./src/components/Models/ButtonBase/ButtonBase.jsx